# frozen_string_literal: true

module Engine
  module Game
    module G1889
    end
  end
end
